import styles from './OEmptyStatus.module.scss';

interface IWebinarStatusProps {
  image: React.ReactNode;
  title: string;
  subDescription?: string;
  className?: string;
}

const OEmptyStatus = ({ image, title, subDescription, className }: IWebinarStatusProps) => {
  return (
    <div className={styles.oEmptyDataContainer + (className ? ` ${className}` : '')}>
      {image}
      <p className={styles.oEmptyDataTitle}>{title}</p>
      <p className={styles.oEmptyDataDescription}>{subDescription}</p>
    </div>
  );
};

export default OEmptyStatus;
